import React, { FC } from "react";
import { ChatListType, ConversationsType } from "../../../types";
import Avatar from "./Avatar";
import Content from "./Content";

interface Props {
  type?: ConversationsType | "home";
  chat?: ChatListType;
}

const ConversationInfo: FC<Props> = (props) => {
  return (
    <>
      <Avatar chat={props?.chat} />
      <Content type={props?.type} chat={props?.chat} />
    </>
  );
};
export default ConversationInfo;
